/**
 * A tenant refused for having no invitation emails their landlord about
 * MNTND (PB-64, Q14 B). The server (`functions/src/functions/inviteLandlord.ts`)
 * sends the email, with its own limits; this only calls it.
 */
import { functionUrl } from '@/services/functionsUrl'
import { logger } from '@/services/logger'

export type LandlordInviteResult =
  | 'sent'
  | 'invalid-email'
  | 'same-email'
  | 'too-many'
  | 'failed'

export async function inviteLandlord(
  tenantEmail: string,
  landlordEmail: string
): Promise<LandlordInviteResult> {
  try {
    const res = await fetch(functionUrl('inviteLandlord'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tenantEmail, landlordEmail }),
    })
    if (res.ok) return 'sent'
    const { error } = (await res.json().catch(() => ({}))) as {
      error?: string
    }
    logger.warn('[inviteLandlord] refused', { status: res.status, error })
    if (error === 'invalid-email' || error === 'same-email') return error
    if (res.status === 429) return 'too-many'
    return 'failed'
  } catch (err) {
    logger.error('[inviteLandlord] request failed', err)
    return 'failed'
  }
}
